/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// actions
// component
import CreateLabels from 'material/embeds/createlabels/createlabels';



/* ========== ~~~~~~~~~~ EDIT LABELS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    labels: embedsState.embedsStatus.labels,
    accountUUID: sessionStatus.accountUUID,
});
// map actions
const mapDispatchToProps = dispatch => ({

});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateLabels));
